<template>
	<Teleport to="body">
		<div class="modal-overlay">
			<slot />
			<div
				class="overlay"
				:style="{
					background: 'rgba(0, 0, 0, ' + opacity + ')',
				}"
				@click="$emit('click')"
			/>
		</div>
	</Teleport>
</template>

<script lang="ts" setup>
defineEmits<{
	click: [];
}>();

withDefaults(
	defineProps<{
		opacity?: number;
	}>(),
	{
		opacity: 0.3,
	},
);
</script>

<style>
.overlay {
	position: absolute;
	z-index: 4;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(27, 27, 29, 0.377);
}
</style>
